/**
 * LUMINA 术语字典 — Phase 101 P1-2
 * 格式: "引擎:术语" → 白话解释（2-3句，含具体例子）
 * 无引擎前缀的条目为通用术语
 */

export const GLOSSARY = {
  // ─── 六爻专用 ──────────────────────────────────────────────────────────────
  "liuyao:用神": "六爻中代表你所问之事的爻。问财→妻财爻为用神，问工作→官鬼爻为用神，问合作→应爻为用神。用神旺相则事可成，休囚死则事难成。",
  "liuyao:世爻": "代表卦主自己的爻。世爻旺相=你当下状态好、能量足；世爻休囚=你能量不足，宜守不宜攻。",
  "liuyao:应爻": "代表对方、外界、事情本身的爻。世克应=主动有利，应克世=对方来压。世应相生=顺利合作。",
  "liuyao:回头克": "动爻变出的地支反过来克制原爻。比如寅爻动化申，申克寅——好比你使了力气，反而被反弹。代表事情有反复、阻碍或外力压制。",
  "liuyao:化绝": "动爻化出的地支处于自己的绝地（十二长生之「绝」）。能量源头断绝，事情最终难以成局，需重新布局。",
  "liuyao:化空": "动爻化出的地支落入空亡。原本的动力悬空、落空，好事打折扣，即使有行动也难有实际结果。",
  "liuyao:化进神": "动爻化出同五行更旺的地支（如寅→卯，卯→寅）。能量递进增强，事情有后劲，越做越顺。",
  "liuyao:化退神": "动爻化出同五行衰退地支（如卯→寅）。势头在减弱，需要加速推进，否则机会窗口关闭。",
  "liuyao:回头生": "动爻化出的地支反过来生扶原爻。好比你出击，反而得到助力。事情有贵人相助或意外顺利。",
  "liuyao:旺相休囚": "爻在当月的能量状态。旺=当令最强；相=有气次强；休=气息减退；囚=受制偏弱；死=能量耗尽。月令是关键——如问于夏月，火爻得令为旺。",
  "liuyao:月破": "爻的地支与当月地支相冲，当月力量被冲散。被冲的爻当月无力，但出了这个月可以恢复，事情出月再看。",
  "liuyao:暗动": "静爻被日辰冲动（称为「暗动」）。虽然表面没有动爻，但被日辰一冲，暗中发动，代表当下有突发变化。",
  "liuyao:伏神": "藏在别爻之下、本卦不现的神。需飞神（上面那个爻）被冲克才能显现，代表隐藏的人或事，需要等待时机。",
  "liuyao:六亲": "父母、兄弟、子孙、妻财、官鬼——六爻中五种六亲爻，对应不同类别的事。父母主文书合同，官鬼主压力或工作，妻财主钱财，子孙主化解，兄弟主竞争耗财。",
  "liuyao:六神": "青龙、白虎、朱雀、玄武、螣蛇、勾陈——六种神灵，附在六爻上决定吉凶气质。青龙主吉庆，白虎主凶险，朱雀主口舌纠纷，玄武主隐秘欺骗，螣蛇主惊惧变故，勾陈主拖延阻滞。",

  // ─── 八字专用 ──────────────────────────────────────────────────────────────
  "bazi:用神": "八字中最需要的五行，能平衡命局偏枯。比如木太旺需金来克，金就是用神；身弱缺印星，印是用神。流年大运见用神则好运来，见忌神则阻碍多。",
  "bazi:喜神": "生扶用神的五行。比如用神为金，土生金，土就是喜神。用神和喜神都是命中的「贵人五行」。",
  "bazi:忌神": "克制用神或加重命局失衡的五行。比如用神为金，火克金→火是忌神；木旺用金→水多沉金→水也是忌神。流年见忌神宜低调守势。",
  "bazi:仇神": "生扶忌神的五行。比如忌神为火，木生火，木是仇神。仇神是忌神的帮凶。",
  "bazi:日主": "出生那天的天干，代表命主自己。如甲木日主=出生于甲日，日主是命局分析的核心基准点。",
  "bazi:身强身弱": "日主在命局中的力量对比。身强=自力旺盛，能担财官，宜打拼进取；身弱=需外力帮扶，宜借助他人、守成保本。不是好坏，是策略不同。",
  "bazi:十神": "日主与其他天干的生克关系标签。克我者=官杀（正官/七杀），我克者=财（正财/偏财），生我者=印（正印/偏印），我生者=食伤（食神/伤官），同我者=比劫（比肩/劫财）。",
  "bazi:正官": "克日主、阴阳相反的五行。代表规则、正统事业、直属上司。女命中正官为夫星（第一夫星）。见正官宜遵守规则、在体制内发展。",
  "bazi:七杀": "克日主、阴阳相同的五行。代表压力、挑战、魄力、竞争。七杀制服（食神制杀/印绶化杀）则成大器；七杀无制则压力失控。",
  "bazi:正财": "日主克、阴阳相反的五行。代表稳定收入、积蓄、脚踏实地。男命正财为妻星。正财旺代表理财稳健、财运踏实。",
  "bazi:偏财": "日主克、阴阳相同的五行。代表横财、投资、副业、人脉广。男命偏财为父星。偏财旺代表善于经营、容易得意外之财。",
  "bazi:食神": "日主生、阴阳相同的五行。代表才华表达、享受生活、创造力、口福。食神制杀是命局的平衡高手，食神旺的人往往有艺术气质或口才好。",
  "bazi:伤官": "日主生、阴阳相反的五行。代表批判力、叛逆、突破创新、口才锋利。伤官见官（正官）时冲突大；伤官佩印（印绶）则化解对立，才华得以正向展现。",
  "bazi:正印": "生日主、阴阳相反的五行。代表学业文凭、长辈贵人、母亲、正统知识体系。正印旺的人学习能力强，贵人相助多。",
  "bazi:偏印": "生日主、阴阳相同的五行。代表非主流技能、玄学天赋、继母（或母亲特殊面）、偏门知识。偏印过旺有时表现为思维飘忽或难以专注。",
  "bazi:大运": "每十年一个阶段的整体能量方向，从起运年开始按岁排列。大运是命局的「气候」，决定那十年的整体顺逆方向。",
  "bazi:流年": "当前年份的天干地支对命局的叠加影响。每年的太岁为「大」，顺太岁者顺，犯太岁者需谨慎。",
  "bazi:调候": "生于某个季节需要某种五行来调节冷暖燥湿——称为调候用神。如夏天生人（火旺）最需要水，冬天生人（水寒）最需要火。调候是第一优先级。",
  "bazi:纳音": "六十甲子每组天干地支对应的声音五行（「纳音」），如甲子乙丑=海中金。纳音是更深层的五行质性，用于性格气质和年命分析。",

  // ─── 紫微专用 ──────────────────────────────────────────────────────────────
  "ziwei:命宫": "紫微斗数中最重要的宫位，决定核心性格、天赋格局、一生底色。主星落命宫，是最直接的「我是谁」信号。",
  "ziwei:化禄": "星曜得到流动福气和财气的加持。该宫位的事顺遂、有收获、如鱼得水。化禄飞入哪个宫，哪个宫的事情就容易顺流。",
  "ziwei:化权": "星曜得到权力、掌控力、决断力的加持。该宫位的事需要主动出手掌舵，也容易得到权位。",
  "ziwei:化科": "星曜得到名声、文凭、才华被认可的加持。该宫位的事容易出名、被认可，适合考试、出版、演讲等。",
  "ziwei:化忌": "星曜受到阻滞、困扰、能量打结。该宫位的事不顺利、有压力——但也是最重要的成长契机，化忌的地方往往是最需要功课的领域。",
  "ziwei:空宫": "某个宫位没有主星落入。空宫不是「没有」，而是需要借对宫主星来参考——就像空房间要看隔壁装了什么。",
  "ziwei:三方四正": "命宫（子女宫）+ 财帛宫 + 官禄宫 + 迁移宫——四个宫位形成能量网，互相牵引。看格局时，三方四正中的星曜都要综合考量。",
  "ziwei:身宫": "后天发展和努力重心所在，30岁后影响力逐渐增强，类似「第二命宫」。身宫的星曜代表你在后半生最需要经营的方向。",
  "ziwei:大限": "紫微斗数中每十年的运势阶段，从命宫出发顺或逆数。每个大限以一个宫位为主，那十年的重点在那个宫位。",
  "ziwei:四化": "化禄、化权、化科、化忌——四种星曜能量的质变形式，由出生年的天干决定哪颗星化什么。四化是紫微盘中最动态、最重要的能量流。",

  // ─── 通用 ──────────────────────────────────────────────────────────────────
  "空亡": "某个地支在当前旬中落空（「虚浮无力」）。事情悬而未决，好事打折，坏事也减轻。出旬后空亡解除，空亡期间不宜签合同、起头大事。",
  "刑冲合害": "地支之间的四种特殊关系：冲=正面对立碰撞（如子午冲），合=相吸结合（如子丑合），刑=刑克扭曲（如寅巳申三刑），害=暗中损害（如子未害）。",
  "地支": "十二地支：子丑寅卯辰巳午未申酉戌亥。代表月份、时辰、方位，以及十二生肖。是命理计算的时间坐标系。",
  "天干": "十天干：甲乙丙丁戊己庚辛壬癸。代表五行+阴阳，是命理横轴。甲乙=木，丙丁=火，戊己=土，庚辛=金，壬癸=水。",
  "五行": "木火土金水——五种基本能量形态。相生（互相滋养）：木→火→土→金→水→木。相克（互相制约）：木→土→水→火→金→木。",
  "干支": "天干+地支的合称，如「甲子」「丁亥」。干支组合用来记录年月日时，四柱就是年月日时四组干支。",
  "四柱": "年柱、月柱、日柱、时柱——用出生的年月日时各对应一组干支，合称「四柱八字」（共8个字）。",
  "节气": "二十四节气是农历的骨架，也是八字排盘的关键：月柱的边界以节气为准，不以农历初一为准。",
};

// 通用短查询表：无引擎前缀时，返回第一个匹配的解释
export const GLOSSARY_SHORT = {};
for (const [k, v] of Object.entries(GLOSSARY)) {
  const base = k.includes(":") ? k.split(":")[1] : k;
  if (!GLOSSARY_SHORT[base]) GLOSSARY_SHORT[base] = v;
}
